/**
 * Repository for the user user-configuration.
 */
export abstract class IsFirstTimeRepo {
  /**
   * When the user logs in for the first time, the following function will
   * be executed to save a key in the local storage.
   * This will help us determine whether or not the user is using the
   * application for the first time.
   * @param isFirstTime
   */
  abstract setIsFirstTime(isFirstTime: boolean): void;
  /**
   * This method is used to determine if the user is using the application for the first time,
   * and if so, redirect them to the onboarding component. To achieve this,
   * a key is stored in the local storage when the user first accesses the application.
   * Then, each time the user logs in, this method is executed to check if the key exists in the local storage.
   * @returns the saved credentials or null if there are no saved credentials.
   */
  abstract getIsFirstTime(): boolean;
}
